module.exports = __webpack_public_path__ + "media/images/logo_s-6ab35ce42ab5be0f7170a4d942220576.png";